var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget widget_tag_cloud"},[_c('h2',{staticClass:"widget-title",class:_vm.params.class},[_vm._v(" "+_vm._s(_vm.$t('Types de bien'))+" ")]),_vm._v(" "),_c('div',{staticClass:"implicit subsection tagcloud"},[_c('h4',_vm._l((_vm.getData),function(tag,index){return _c('nuxt-link',{key:index,attrs:{"to":_vm.getLocalizedRoute({
                name: _vm.getRouteName
                , params: {
                    category: _vm.$tradLinkSlug(_vm.$store.state.i18n.currentLocale, tag.slug, 'accommodationType')
                }
            })}},[_vm._v("\n            "+_vm._s(_vm.$t(tag.name))+"\n        ")])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }